/**
 * Spanish (es) locale - Split files merged
 */

import common from './common.json';
import auth from './auth.json';
import editor from './editor.json';
import gameLogic from './gameLogic.json';
import social from './social.json';
import monetization from './monetization.json';
import game from './game.json';

const es = {
  ...common,
  ...auth,
  ...editor,
  ...gameLogic,
  ...social,
  ...monetization,
  ...game,
};

export default es;
